<template lang="pug">
#outing-detail
  //- title
  .d-flex.flex-row.justify-content-center.mb-1(v-if="outing")
    .page-title
      span {{ _typeName }}届け出詳細

  .mb-3.separator(v-if="outing")

  .content(v-if="outing")
    //- resident
    .mb-0
      span.key-name 利用者名（部屋名）
    .mb-3
      span {{ outing.targetResidentInfo.name }}（{{ outing.targetResidentInfo.roomName }}）

    //- status
    .mb-0
      span.key-name 状態
    .mb-3
      span.status-no-consented(v-if="outing.consented == false") 未承諾（{{ _inputType }}）
      span.status-consented(v-else) 承諾済（{{ _inputType }}）

    //- datetime
    .mb-0
      span.key-name(v-if="outing.type == 'goingOut'") 外出日時
      span.key-name(v-if="outing.type == 'stayingOut'") 外泊日時
    .mb-3
      .d-flex.flex-column(v-if="outing.type == 'goingOut'")
        .d-flex.flex-row.align-items-center.flex-wrap
          span {{ getDate(outing.startDatetime) }}（
          span(:class="weekCssClass(outing.startDatetime)") {{ getWeek(outing.startDatetime) }}）
          span {{ getTime(outing.startDatetime) }}
          span ～
          span {{ getTime(outing.endDatetime) }}
      .d-flex.flex-column(v-if="outing.type == 'stayingOut'")
        .d-flex.flex-row.align-items-center.flex-wrap
          span {{ getDate(outing.startDatetime) }}（
          span(:class="weekCssClass(outing.startDatetime)") {{ getWeek(outing.startDatetime) }}）
          span {{ getTime(outing.startDatetime) }}
          span.mr-1.ml-1 ～
          span {{ getDate(outing.endDatetime) }}（
          span(:class="weekCssClass(outing.endDatetime)") {{ getWeek(outing.endDatetime) }}）
          span {{ getTime(outing.endDatetime) }}

    //- location
    .mb-0
      span.key-name 主な外出場所
    .mb-3
      span {{ _location }}

    //- applicantFamily
    .mb-0
      span.key-name 申請者（続柄）
    .mb-3
      span {{ _applicantFamily }}

    //- applicantFamily
    .mb-0
      span.key-name お迎えに来る方（続柄）
    .mb-3
      span {{ _applicantPickup }}

    //- selectedVehicle
    .selected-vehicle(v-if="_showSelectedVehicle")
      .mb-0
        span.key-name 外出手段
      .mb-3
        span(v-if="_selectedVehicle") {{ _selectedVehicle }}
        span.error-message(v-else) 未設定

    //- needsMeals
    .mb-0
      span.key-name 施設での食事
    .mb-3
      OutingDetailNeedsMealsTable(v-model="_needsMealItems" :fields="needsMealFields")

    //- text
    .mb-0
      span.key-name 家族からの連絡事項
    .mb-3
      span(v-if="_text") {{ _text }}
      span.error-message(v-else) 未設定

    //- controll
    .mb-0
      span.key-name 届出の操作
    .mb-4
      template(v-if="outing.consented == false")
        b-button.btn.back-btn.mr-2(@click="onConsented(outing)") 承諾
        b-button.btn.back-btn.mr-2(@click="onUnconsented(outing)") 辞退
      template(v-else)
        b-button.btn.back-btn.mr-2(@click="onConsentedCancel(outing)") キャンセル

    //- error message
    .mb-4(v-if="errorMessage != ''")
      span.error-message {{ errorMessage }}

    //- buttons
    .d-flex.flex-row.justify-content-center
      b-button.btn.edit-btn.mr-2(@click="onEdit") 修正
      b-button.btn.back-btn(@click="onBack") 戻る

  //- loading modal
  Loading(:isBusy="isBusy" :message="loadingMessage")

  //- consented modals
  OkCancelModal(v-model="showConsentedModal" :title="consentedModalTitle" @ok="onConsentedModalOk")
  OkModal(v-model="showConsentedSuccessModal" :title="consentedSuccessModalTitle" @ok="onConsentedSuccessModalOk")

  //- unconsented modals
  MessageModal(v-model="showUnconsentedRegisterModal" :modalTitle="messageModalTitle" :modalMessage="messageModalMessage"
    :title.sync="messageTitle" :text.sync="messageText" @onSend="confirmUnconsented")
  MessageConfirmModal(v-model="showUnconsentedRegisterConfirmModal" :modalTitle="messageConfirmModalTitle" :title="messageTitle" :text="messageText"
    @onSend="unconsented")

  //- cancel modals
  OkCancelModal(v-model="showConsentedCancelRegisterModalByNoMessage" :title="modalMessage" :message="modalOptionMessage" @ok="consentedCancel")
  MessageModal(v-model="showConsentedCancelRegisterModal" :modalTitle="messageModalTitle" :modalMessage="messageModalMessage"
    :title.sync="messageTitle" :text.sync="messageText" @onSend="confirmConsentedCancel")
  MessageConfirmModal(v-model="showConsentedCancelRegisterConfirmModal" :modalTitle="messageConfirmModalTitle" :title="messageTitle" :text="messageText"
    @onSend="consentedCancel")

  //- success modals(unconsented, cancel)
  OkModal(v-model="showOkModal" :title="okModalTitle" @ok="onBack")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { MobileUrl } from "@/commons/constants/MobileUrl";

import SystemError from "@/commons/models/SystemError";
import OutingsService, { InputBy, NeedsMeal, OutingGetModel, OutingStatusPatchModel, OutingType, UpdateOutingStatusType } from "@/commons/services/Outings";
import OutingSettingsService, { OutingSettingGetModel } from "@/commons/services/OutingSettings";
import FamiliesService, { FamilyGetModel, SenderType } from "@/commons/services/Families";

import Loading from "@/mobile/basics/Loading.vue";
import OkCancelModal from "@/mobile/basics/OkCancelModal.vue";
import OkModal from "@/mobile/basics/OkModal.vue";
import MessageModal from "@/mobile/components/modals/MessageModal.vue";
import MessageConfirmModal from "@/mobile/components/modals/MessageConfirmModal.vue";
import OutingDetailNeedsMealsTable, { OutingDetailNeedsMealsTableField, OutingDetailNeedsMealsTableItem } from "@/mobile/components/tables/OutingDetailNeedsMealsTable.vue";

/**
 * ### 外出外泊届け詳細コンポーネント
 */
@Component({
  components: {
    Loading,
    OkCancelModal,
    OkModal,
    MessageModal,
    MessageConfirmModal,
    OutingDetailNeedsMealsTable
  }
})
export default class ReservationDetail extends Vue {
  /** 外出外泊サービス */
  @Inject("OutingsService") outingsService!: OutingsService;
  /** 外出外泊設定サービス */
  @Inject("OutingSettingsService") outingSettingsService!: OutingSettingsService;
  /** 家族ユーザーサービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;

  /** ローディングモーダル表示可否 */
  isBusy: boolean = false;
  /** ローディングモーダルメッセージ */
  loadingMessage: string = "";

  /** エラーメッセージ */
  errorMessage: string = "";

  /** 外出外泊届け */
  outing: OutingGetModel | null = null;
  /** 外出外泊届け設定 */
  setting: OutingSettingGetModel | null = null;

  /** 食事等のテーブル行 */
  needsMealItems: Array<OutingDetailNeedsMealsTableItem> = [];
  /** 食事等のテーブル列 */
  needsMealFields: Array<OutingDetailNeedsMealsTableField> = [];

  /** 承諾確認モーダル表示可否 */
  showConsentedModal: boolean = false;
  /** 承諾確認モーダルタイトル */
  consentedModalTitle: string = "";
  /** 承諾完了モーダル表示可否 */
  showConsentedSuccessModal: boolean = false;
  /** 承諾完了モーダルタイトル */
  consentedSuccessModalTitle: string = "";

  /** 辞退メッセージ入力モーダル表示可否 */
  showUnconsentedRegisterModal: boolean = false;
  /** 辞退メッセージ確認モーダル表示可否 */
  showUnconsentedRegisterConfirmModal: boolean = false;

  /** キャンセル確認モーダル表示可否 */
  showConsentedCancelRegisterModalByNoMessage: boolean = false;
  /** キャンセルメッセージ入力モーダル表示可否 */
  showConsentedCancelRegisterModal: boolean = false;
  /** キャンセルメッセージ確認モーダル表示可否 */
  showConsentedCancelRegisterConfirmModal: boolean = false;

  /** メッセージ入力モーダルのタイトル */
  messageModalTitle: string = "";
  /** メッセージ入力モーダルのメッセージ */
  messageModalMessage: string = "";
  /** メッセージタイトル */
  messageTitle: string = "";
  /** メッセージ本文 */
  messageText: string = "";
  /** メッセージ入力確認モーダルのタイトル */
  messageConfirmModalTitle: string = "";
  /** 単一モーダル表示のメッセージ */
  modalMessage: string = "";
  /** 単一モーダルオプションメッセージ */
  modalOptionMessage: string = "";

  /** 辞退、キャンセル完了モーダル表示可否 */
  showOkModal: boolean = false;
  /** 辞退、キャンセル完了モーダルタイトル */
  okModalTitle: string = "";

  /** ### 届出種類 */
  get _typeName(): string {
    if (!this.outing) {
      return "";
    }
    return this.outing.type == OutingType.GOING_OUT ? "外出" : this.outing.type == OutingType.STAYING_OUT ? "外泊" : "";
  }
  /** 届け出状態 */
  get _inputType(): string {
    if (this.outing && this.outing.inputBy == InputBy.FACILITY) {
      return "代理届け";
    } else {
      return "本人届け";
    }
  }
  /** 主な外出先 */
  get _location(): string {
    if (!this.outing) {
      return "";
    }
    return this.outing.location;
  }
  /** ### 申請者 */
  get _applicantFamily(): string {
    if (!this.outing) {
      return "";
    }
    return `${this.outing.applicantFamilyInfo.name}（${this.outing.applicantFamilyInfo.relation}）`;
  }
  /** ### お迎えに来る方 */
  get _applicantPickup(): string {
    if (!this.outing) {
      return "";
    }
    // 申請者と同じ場合は固定文字列を返す
    if (this.outing.applicantPickup) {
      return "申請者と同じ";
    }
    // お迎えに来る方情報が存在する場合は家族名（続柄）を返す
    else if (this.outing.pickupPerson) {
      return `${this.outing.pickupPerson.name}（${this.outing.pickupPerson.relation}）`;
    } else {
      return "";
    }
  }
  /** 外出手段 */
  get _showSelectedVehicle(): boolean {
    if (!this.outing || !this.setting) {
      return false;
    } else {
      return this.setting.useSelectedVehicle;
    }
  }
  /** 外出手段 */
  get _selectedVehicle(): string {
    if (!this.outing || !this.outing.selectedVehicle) {
      return "";
    }
    return this.outing.selectedVehicle;
  }
  /** 施設での食事 */
  get _needsMealItems(): Array<OutingDetailNeedsMealsTableItem> {
    if (!this.outing) {
      return [];
    }

    const items: Array<OutingDetailNeedsMealsTableItem> = [];
    items.push({
      datetime: this.outing.startDatetime,
      needsMeal: this.outing.startDateNeedsMeal
    });
    if (this.outing.type == OutingType.STAYING_OUT) {
      items.push({
        datetime: this.outing.endDatetime,
        needsMeal: this.outing.endDateNeedsMeal as NeedsMeal
      });
    }
    return items;
  }
  /** 家族からの連絡事項 */
  get _text(): string {
    if (!this.outing || !this.outing.text) {
      return "";
    }
    return this.outing.text;
  }

  /**
   * ### vue lifecycle mounted
   */
  async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報を作成する
   */
  async createView(): Promise<void> {
    this.loadingMessage = "読込み中";
    this.isBusy = true;

    const setting: OutingSettingGetModel = await this.getOutingSetting();
    this.setting = setting;
    const needsMealFields = this.createNeedsMealFields(setting);
    this.needsMealFields = needsMealFields;

    const id: string = this.$route.params.id;
    const outing: OutingGetModel = await this.getOuting(Number(id));
    this.outing = outing;

    this.isBusy = false;
  }

  /**
   * ### 外出外泊届け設定取得
   */
  async getOutingSetting(): Promise<OutingSettingGetModel> {
    const response: OutingSettingGetModel = await this.outingSettingsService.get(userStore);
    return response;
  }

  /**
   * ### テーブル列名を作成する
   */
  createNeedsMealFields(setting: OutingSettingGetModel): Array<OutingDetailNeedsMealsTableField> {
    const fields: Array<OutingDetailNeedsMealsTableField> = [];
    fields.push({ key: "date", label: "日", sortable: false, sortDirection: "desc", class: "date text-center" });

    // 食事列は設定に応じて表示／非表示を切り替える
    if (setting.useNeedsMeal.breakfast) {
      fields.push({ key: "breakfast", label: "朝食", sortable: false, sortDirection: "desc", class: "meal-name breakfast text-center" });
    }
    if (setting.useNeedsMeal.lunch) {
      fields.push({ key: "lunch", label: "昼食", sortable: false, sortDirection: "desc", class: "meal-name lunch text-center" });
    }
    if (setting.useNeedsMeal.snack) {
      fields.push({ key: "snack", label: "おやつ", sortable: false, sortDirection: "desc", class: "meal-name snack text-center" });
    }
    if (setting.useNeedsMeal.dinner) {
      fields.push({ key: "dinner", label: "夕食", sortable: false, sortDirection: "desc", class: "meal-name dinner text-center" });
    }
    return fields;
  }

  /**
   * ### 外出外泊届けを取得する
   */
  async getOuting(outingId: number): Promise<OutingGetModel> {
    const response: OutingGetModel = await this.outingsService.get(userStore, outingId);
    return response;
  }

  /**
   * ### 日付(yyyy年mm月dd日)を返す
   * */
  getDate(datetime: number): string {
    if (datetime) {
      return this.$dateUtil.convertNumberToString(Number(datetime), "mm月dd日", false);
    } else {
      return "";
    }
  }

  /**
   * ### 曜日を返す
   */
  getWeek(datetime: number): string {
    if (datetime) {
      const dateObject: Date = this.$dateUtil.convertNumberToDate(Number(datetime));
      return this.$dateUtil.getWeekName(dateObject, "ja");
    } else {
      return "";
    }
  }

  /**
   * ### 時分を返す
   */
  getTime(datetime: number): string {
    if (datetime) {
      return this.$dateUtil.convertNumberToString(Number(datetime), "hh:MM");
    } else {
      return "";
    }
  }

  /**
   * ### 曜日の文字色CssClassの割り当て
   */
  weekCssClass(datetime: number): string {
    if (datetime) {
      let weekClassName: string = "";
      const weekName: string = this.getWeek(datetime);
      switch (weekName) {
        case "日":
          weekClassName = "sunday";
          break;
        case "土":
          weekClassName = "saturday";
          break;
        default:
          break;
      }
      return weekClassName;
    } else {
      return "";
    }
  }

  /**
   * ### 承諾確認モーダルを表示する
   */
  onConsented(outing: OutingGetModel): void {
    const residentName = `${outing.targetResidentInfo.name}（${outing.targetResidentInfo.roomName}）`;
    const familyName = `${outing.applicantFamilyInfo.name}（${outing.applicantFamilyInfo.relation}）`;
    const message: string = `${residentName}様の${familyName}の外出外泊届けを承諾しますか？`;
    this.consentedModalTitle = message;
    this.showConsentedModal = true;
    return;
  }

  /**
   * ### 外出外泊届けを承諾する
   */
  async onConsentedModalOk(): Promise<void> {
    this.loadingMessage = "承諾中";
    this.isBusy = true;

    try {
      if (this.outing) {
        // 登録用情報を作成し、APIにリクエストを送る
        const requestBody: OutingStatusPatchModel = {
          statusType: UpdateOutingStatusType.CONSENTED,
          text: "",
          title: "",
          updated: Number(this.outing.updated)
        };
        await this.outingsService.patchStatus(userStore, this.outing.id, requestBody);
      }

      this.consentedSuccessModalTitle = "承諾しました。";
      this.showConsentedSuccessModal = true;
    } catch (error) {
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 承諾完了モーダルのOKボタン押下イベント
   */
  async onConsentedSuccessModalOk(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 辞退確認モーダルを表示する
   */
  async onUnconsented(outing: OutingGetModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読み込み中...";

    await this.setMessageModalTitleAndText(outing, "辞退");

    this.isBusy = false;
    this.showUnconsentedRegisterModal = true;

    return;
  }

  /**
   * ### メッセージモーダルで表示する情報を格納する
   *
   * - モーダルのタイトル
   * - モーダルのメッセージ(説明文)
   * - メッセージのタイトル
   * - メッセージ本文
   *   - 送信対象の家族がLINEかメールかで本文の内容が異なる
   */
  async setMessageModalTitleAndText(outing: OutingGetModel, operation: string): Promise<void> {
    // モーダルタイトル等で使用する利用者、家族、種別を作成
    const residentName: string = `${outing.targetResidentInfo.name}（${outing.targetResidentInfo.roomName}）`;
    const familyName: string = `${outing.applicantFamilyInfo.name}（${outing.applicantFamilyInfo.relation}）`;
    const typeName: string = outing.type == OutingType.GOING_OUT ? "外出届け" : outing.type == OutingType.STAYING_OUT ? "外泊届け" : "";

    // 家族を指定していない代理届けの場合はメッセージモーダルではなく既存のモーダルを表示する
    const splitedResidentsSortKey: string[] = outing.residentsSortKey.split("_");
    if (Number(splitedResidentsSortKey[1]) == 0 && outing.inputBy == InputBy.FACILITY) {
      this.modalMessage = `${residentName}様の${familyName}の${typeName}を${operation}しますか？`;
      this.modalOptionMessage = `登録されていないご家族からの${typeName}のため、自動通知がありません。お電話でのご連絡をお願いします。`;
      this.messageTitle = "";
      this.messageText = "";
    }
    // 代理届け以外の場合はメッセージモーダルを表示する
    else {
      // 家族が存在する場合、辞退、キャンセル（メッセージ入力）モーダルを表示する
      const family: FamilyGetModel | null = await this.getFamily(Number(splitedResidentsSortKey[0]), Number(splitedResidentsSortKey[1]));
      if (family) {
        const startDate: string = this.$dateUtil.convertNumberToString(outing.startDatetime, "mm月dd日");
        const startWeekName: string = this.getWeek(outing.startDatetime);
        const startTime: string = this.$dateUtil.convertNumberToString(outing.startDatetime, "hh:MM");
        const endDate: string = this.$dateUtil.convertNumberToString(outing.endDatetime, "mm月dd日");
        const endTime: string = this.$dateUtil.convertNumberToString(outing.endDatetime, "hh:MM");
        const endWeekName: string = this.getWeek(outing.endDatetime);
        const datetime: string =
          outing.type == OutingType.GOING_OUT
            ? `${startDate}（${startWeekName}） ${startTime}～${endTime}`
            : outing.type == OutingType.STAYING_OUT
            ? `${startDate}（${startWeekName}） ${startTime}～${endDate}（${endWeekName}） ${endTime}`
            : "";

        // メッセージモーダルのタイトル、本文
        this.messageModalTitle = `${residentName}様の${familyName}の${typeName}を${operation}しますか？`;
        this.messageModalMessage = `ご家族へのメッセージ内容を編集して送信してください。\n送信すると${typeName}が取り消されます。`;
        // 送信メッセージのタイトル、本文の初期入力
        this.messageTitle = `${typeName}の${operation}（${datetime}）`;
        const texts: string[] = [];
        if (family.senderType == SenderType.LINE) {
          // LINEメッセージ送信
          texts.push(`${userStore.facility.name}  ${family.name}様`);
          texts.push(`${datetime}の${typeName}が施設のご都合により${operation}されました。\n`);
          texts.push(`別の日程等を選択して再申請をお願いします。`);
        } else if (family.senderType == SenderType.MAIL) {
          // メール送信
          texts.push(`HitomeQ コネクト のご家族向けメール配信サービスです。\n`);
          texts.push(`${userStore.facility.name}のご都合により、${typeName}が${operation}されました。`);
          texts.push(`予約日時: ${datetime}\n`);
          texts.push(`別日程での再申請をご希望の場合は、${userStore.facility.name}へご連絡ください。\n\n`);
          texts.push(`このメールへの返信はできませんのでご了承ください。`);
          texts.push(`配信停止をご希望の場合は、ご利用の施設までご連絡ください。`);
        }
        this.messageText = texts.join("\n");
      }
    }

    return;
  }

  /**
   * ### 家族を取得する
   *
   * - 家族単一を取得するAPIはないので、利用者にひもづく家族を取得する
   * - 家族の中から家族IDが同一のものを修正対象の家族と判断する
   * - 見つからなかった場合は404画面に遷移させたいので例外を投げる
   */
  async getFamily(residentId: number, familyId: number): Promise<FamilyGetModel> {
    const families: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, residentId);

    for (const family of families) {
      if (family.familyId == familyId) {
        return family;
      }
    }

    let systemError: SystemError = new SystemError(`family is notfound. residentId: ${residentId}, familyId: ${familyId}.`);
    systemError.statusCode = 404;
    throw systemError;
  }

  /**
   * ### 辞退確認ダイアログを表示する
   */
  confirmUnconsented(): void {
    const outing: OutingGetModel = this.outing as OutingGetModel;
    const residentName = `${outing.targetResidentInfo.name}（${outing.targetResidentInfo.roomName}）`;
    const familyName = `${outing.applicantFamilyInfo.name}（${outing.applicantFamilyInfo.relation}）`;
    this.messageConfirmModalTitle = `${residentName}様の${familyName}に以下の内容でメッセージを送信します。よろしいですか？`;
    this.showUnconsentedRegisterConfirmModal = true;
    return;
  }

  /**
   * ### 外出外泊届けを辞退する
   */
  async unconsented(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "辞退中...";

    this.showUnconsentedRegisterConfirmModal = false;
    this.showUnconsentedRegisterModal = false;

    const outing: OutingGetModel = this.outing as OutingGetModel;
    const requestBody: OutingStatusPatchModel = {
      statusType: UpdateOutingStatusType.REFUSE,
      text: this.messageText,
      title: this.messageTitle,
      updated: Number(outing.updated)
    };
    await this.outingsService.patchStatus(userStore, outing.id, requestBody);

    this.okModalTitle = "辞退しました。";
    this.showOkModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### 承諾キャンセルモーダルを表示する
   *
   * - 家族IDが0(代理届けではないか、登録済み家族の代理届けではない)であればモーダルに追加メッセージを表示する
   */
  async onConsentedCancel(outing: OutingGetModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読み込み中...";

    await this.setMessageModalTitleAndText(outing, "キャンセル");

    this.isBusy = false;

    // メッセージが送れるか否かで表示するモーダルを切り替える
    const splitedResidentsSortKey: string[] = outing.residentsSortKey.split("_");
    if (Number(splitedResidentsSortKey[1]) == 0 && outing.inputBy == InputBy.FACILITY) {
      this.showConsentedCancelRegisterModalByNoMessage = true;
    } else {
      this.showConsentedCancelRegisterModal = true;
    }

    return;
  }

  /**
   * ### 承諾キャンセル確認ダイアログを表示する
   */
  confirmConsentedCancel(): void {
    const outing: OutingGetModel = this.outing as OutingGetModel;
    const residentName = `${outing.targetResidentInfo.name}（${outing.targetResidentInfo.roomName}）`;
    const familyName = `${outing.applicantFamilyInfo.name}（${outing.applicantFamilyInfo.relation}）`;
    this.messageConfirmModalTitle = `${residentName}様の${familyName}に以下の内容でメッセージを送信します。よろしいですか？`;
    this.showConsentedCancelRegisterConfirmModal = true;
    return;
  }

  /**
   * ### 外出外泊届けをキャンセルする
   */
  async consentedCancel(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "キャンセル中...";

    this.showConsentedCancelRegisterConfirmModal = false;
    this.showConsentedCancelRegisterModal = false;

    const outing: OutingGetModel = this.outing as OutingGetModel;
    const requestBody: OutingStatusPatchModel = {
      statusType: UpdateOutingStatusType.CANCEL,
      text: this.messageText,
      title: this.messageTitle,
      updated: Number(outing.updated)
    };
    await this.outingsService.patchStatus(userStore, outing.id, requestBody);

    this.okModalTitle = "キャンセルしました。";
    this.showOkModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  onEdit(): void {
    this.$router.push({ name: MobileUrl.OutingEdit, params: { id: this.$route.params.id } });
    return;
  }

  /**
   * ### 戻るボタン押下イベント
   */
  onBack(): void {
    const page: string = this.$route.params.page;
    this.$router.push({ name: MobileUrl.OutingList, params: { page: page } });
    return;
  }

  /**
   * ### フッターを表示する
   */
  showFooter(): void {
    this.$emit("updateShowFooter", true);
    return;
  }

  /**
   * ### フッターを非表示にする
   */
  hideFooter(): void {
    this.$emit("updateShowFooter", false);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/mobile/_mixin.scss";
@import "../../../styles/mobile/_colors.scss";

#outing-detail {
  .sunday {
    color: $font-sunday;
  }
  .saturday {
    color: $font-saturday;
  }

  .edit-text {
    color: $font-base;
    opacity: 0.5;
    text-shadow: 0 1px 0 #fff;
    cursor: pointer;
  }
  .edit-text:hover {
    opacity: 0.75;
  }
  .outing-text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .status-consented {
    color: $font-disable;
    font-weight: bold;
  }
  .status-no-consented {
    color: $font-strong;
    font-weight: bold;
  }
}
</style>
